import {Dispatcher} from 'flux';

import {type FluxAction} from 'constants/EventConstants';

export type {FluxAction};

export default new Dispatcher<FluxAction>();
